export const validateEmail = (email: string | undefined) => {
  if (typeof email === 'string') {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(email);
  }
  return false;
};
